<template>
    <div class="tips">
        报告结果请截图保存，以便后续查看
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.tips {
    width: 100%;
    text-align: center;
    height: 64px;
    line-height: 64px;
    color: #fff;
    background: #FF6010;
    font-size: 28px;
}
</style>